import { Controller } from "@hotwired/stimulus"

// CSP-safe replacement for <img onerror="…"> logo fallbacks: hide the broken
// image and reveal the sibling placeholder. connect() covers images that
// already failed before Stimulus attached (cached 404s fire no error event).
export default class extends Controller {
  static values = { display: { type: String, default: "flex" } }

  connect() {
    if (this.element.complete && this.element.naturalWidth === 0) this.swap()
  }

  swap() {
    this.element.style.display = "none"
    const sib = this.element.nextElementSibling
    if (sib) sib.style.display = this.displayValue
  }
}
